import { resolveCursorContext } from './resolveCursorContext.js';
import { resolveStepResolution } from './resolveStepResolution.js';
const ok = (value) => ({
    ok: true,
    value,
});
const err = (error) => ({
    ok: false,
    error,
});
export function resolveNodeExecutionContextAtCursor(args) {
    const cursorContextResult = resolveCursorContext({
        nodeName: args.nodeName,
        state: args.state,
    });
    if (!cursorContextResult.ok) {
        return err(cursorContextResult.error);
    }
    const cursorContext = cursorContextResult.value;
    const stepResolutionResult = resolveStepResolution({
        nodeName: args.nodeName,
        currentThreadIndex: cursorContext.currentThreadIndex,
        currentStepCounter: cursorContext.currentStepCounter,
        threadSteps: cursorContext.threadSteps,
        toolMap: args.state.toolMap,
    });
    if (!stepResolutionResult.ok) {
        return err(stepResolutionResult.error);
    }
    const nodeExecutionContext = {
        cursorContext,
        stepResolution: stepResolutionResult.value,
    };
    return ok(nodeExecutionContext);
}
